import { createContext } from 'react';
import { ConflictResolution } from '../types';

export interface ConflictsContext {
  setResolution: (key: string, resolution: ConflictResolution) => void;
  sourceLabel: string;
  targetLabel: string;
}

export const ConflictsContext = createContext<ConflictsContext | null>(null);
